import React from 'react'
import AboutMeContainer from '../components/AboutMeContainer'

function AboutMe() {
    return (
        <AboutMeContainer />
    )
}

export default AboutMe